var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcAccessIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67647 6.82356H8.76471C8.98334 6.82356 9.09266 6.82356 9.18375 6.80653C9.58961 6.73066 9.90711 6.41316 9.98297 6.00731C10 5.91622 10 5.8069 10 5.58826V5.58826C10 5.15099 10 4.93235 9.96595 4.75018C9.81421 3.93847 9.17921 3.30346 8.3675 3.15173C8.18533 3.11768 7.96669 3.11768 7.52941 3.11768H3.96471C3.06594 3.11768 2.61656 3.11768 2.26032 3.25949C1.74962 3.46278 1.3451 3.8673 1.14181 4.37799C1 4.73424 1 5.18362 1 6.08238V6.08238C1 6.30707 1 6.41942 1.03545 6.50848C1.08628 6.63615 1.1874 6.73728 1.31508 6.78811C1.40414 6.82356 1.51649 6.82356 1.74118 6.82356H2.32353",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58838 9.83558L2.58838 6.70577C2.58838 5.76296 2.58838 5.29155 2.88127 4.99866C3.17417 4.70577 3.64557 4.70577 4.58838 4.70577L6.41191 4.70577C7.35472 4.70577 7.82612 4.70577 8.11901 4.99866C8.41191 5.29155 8.41191 5.76296 8.41191 6.70577L8.41191 9.83558C8.41191 10.1521 8.41191 10.3104 8.30809 10.3853C8.20426 10.4601 8.05411 10.41 7.75379 10.3099L6.99743 10.0578C6.91146 10.0291 6.86848 10.0148 6.82415 10.0161C6.77982 10.0174 6.73775 10.0343 6.65362 10.0679L5.68584 10.455C5.59414 10.4917 5.54829 10.51 5.50014 10.51C5.452 10.51 5.40615 10.4917 5.31445 10.455L4.34667 10.0679C4.26253 10.0343 4.22047 10.0174 4.17614 10.0161C4.13181 10.0148 4.08883 10.0291 4.00286 10.0578L3.24649 10.3099C2.94618 10.41 2.79602 10.4601 2.6922 10.3853C2.58838 10.3104 2.58838 10.1521 2.58838 9.83558Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 6.82373L6.29392 6.82373",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 8.41162L6.82333 8.41162",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41191 3.11765V3.11765C8.41191 2.82259 8.41191 2.67506 8.39465 2.55132C8.28351 1.75463 7.65727 1.12839 6.86059 1.01726C6.73685 1 6.58932 1 6.29426 1H4.70603C4.41097 1 4.26344 1 4.1397 1.01726C3.34301 1.12839 2.71677 1.75463 2.60564 2.55132C2.58838 2.67506 2.58838 2.82259 2.58838 3.11765V3.11765",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcAccessIconWhite);
export default __webpack_public_path__ + "static/media/cp-pc-access-icon-white.0bef46d26e21c7a0ab901daac0efa401.svg";
export { ForwardRef as ReactComponent };